/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    TextField,
    Toolbar,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import React from 'react';
import { IFormularioFamiliasVistaProps } from '../interfaces';
const FormularioFamiliasVista: React.FunctionComponent<IFormularioFamiliasVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    familias,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <ModalEncabezado
            cerrar={cerrarFormulario}
            titulo={
                <Texto
                    align="center"
                    color="inherit"
                    id={
                        tipoFormulario === TipoFormulario.Creacion
                            ? 'familias.agregarFamilias'
                            : 'familias.modificarFamilias'
                    }
                />
            }
        />
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="familias.familiaDescripcion" display="inline" />}
                        name="FamiliaDescripcion"
                        onChange={cambiarInfoFomulario}
                        required
                        value={familias.FamiliaDescripcion}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={Number(familias.Estado) === 1 ? true : false}
                                onChange={cambiarInfoFomulario}
                            />
                        }
                        label={<Texto id="productos.estado" display="inline" />}
                        name="Estado"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained">
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioFamiliasVista;
